import { render, staticRenderFns } from "./the-add-partners.vue?vue&type=template&id=e67f2d86&scoped=true&"
import script from "./the-add-partners.vue?vue&type=script&lang=js&"
export * from "./the-add-partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67f2d86",
  null
  
)

export default component.exports